module.exports = __webpack_public_path__ + "i18n/es.7066b00607485f360394012e799198e8.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/es.json
// module id = 1001
// module chunks = 60